import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

// 
const sliders = document.querySelectorAll('[js-slider-mobile]')
let swiperArr = []

if (sliders.length > 0) {
 for(const slider of sliders) {
   const wrapper = slider.querySelector('.swiper-wrapper')
   const slides = wrapper.children
   let i = 0;

    for(const slide of slides) {
      slide.classList.add('swiper-slide')
      i += 1
      if (i === slides.length) {
        if (window.innerWidth <= 768 ) swiperArr.push(initSlider(slider))
      }
    }
  } 
}

window.addEventListener('resize', () => {
  if (window.innerWidth > 768) {
    for(const swiper of swiperArr) {
      swiper.destroy()
    }
  } else {
    swiperArr = []
    for (const slider of sliders) {
      swiperArr.push(initSlider(slider))
    }
  }
})

function initSlider(slider) {
  const swiper = new Swiper(slider, {
    spaceBetween: 16,
    slidesPerView: 'auto',
    loop: slider.dataset.loop,
  })

  return swiper
}